import log from 'salvo-lite/log'

class TrackingCode {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        let redirectURL = this._elem.href
        if (this.getParameterByName('utm_source')) {
            redirectURL = `${redirectURL}&utm_source=${this.getParameterByName('utm_source')}`
            if (this.getParameterByName('utm_medium')) {
                redirectURL = `${redirectURL}&utm_medium=${this.getParameterByName('utm_medium')}`
            }
            if (this.getParameterByName('utm_campaign')) {
                redirectURL = `${redirectURL}&utm_campaign=${this.getParameterByName('utm_campaign')}`
            }
        }
        this._elem.href = redirectURL
    }

    getParameterByName (name, url) {
        if (!url) url = window.location.href
        name = name.replace(/[[]]/g, '\\$&')
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
        let results = regex.exec(url)
        if (!results) return null
        if (!results[2]) return ''
        return decodeURIComponent(results[2].replace(/\+/g, ' '))
    }
}

export default TrackingCode



// WEBPACK FOOTER //
// ./src/resources/scripts/components/TrackingCode.js